import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { sharedStyles } from '../../utils/Style';

interface YoutubePreviewDialogProps {
  title?: string;
  videoID: string;
  open: boolean;
  onClose: () => void;
}

export const YoutubePreviewDialog = (props: YoutubePreviewDialogProps) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '690px', // Set your width here
          },
        },
      }}
    >
      <DialogTitle>{props.title ?? 'YouTube Videosu'}</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          component='iframe'
          src={`https://www.youtube.com/embed/${props.videoID}`}
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
          allowFullScreen
          sx={{
            height: 390,
            width: 640,
          }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 1.5 }}>
        <Button
          variant='contained'
          color='inherit'
          onClick={props.onClose}
          sx={sharedStyles.buttonText}
        >
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
};
